import { Moment } from "moment-timezone";
import React, { ChangeEvent, Component } from "react";
import "./CreateLotSidebar.scss";
import IGetCatalogsDTO from "../../../models/DTO/IGetCatalogsDTO";
import IOnGetCatalogsDTO from "../../../models/DTO/IOnGetCatalogsDTO";
import IOnProcessLotDTO from "../../../models/DTO/IOnProcessLotDTO";
import IOnTypeaheadCatalogItemDTO from "../../../models/DTO/IOnTypeaheadCatalogItemDTO";
import IProcessLotDTO from "../../../models/DTO/IProcessLotDTO";
import ITypeaheadCatalogItemDTO from "../../../models/DTO/ITypeaheadCatalogItemDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ICatalog from "../../../models/ICatalog";
import ICatalog_Item from "../../../models/ICatalog_Item";
import ILot from "../../../models/ILot";
import INewLot from "../../../models/INewLot";
import ISupplierModel from "../../../models/ISupplierModel";
import IUser from "../../../models/IUser";
import OwButton from "../../shared/OwButton/OwButton";
import OwDateInput from "../../shared/OwDateInput/OwDateInput";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../shared/OwTitle/OwTitle";
import Typeahead from "../../shared/Typeahead/Typeahead";
import { Socket } from "socket.io-client";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";

type Props = {
    userModel: IUser;
    supplierModel: ISupplierModel;
    socket: Socket;
    cancel: (refresh?: boolean, data?: IOnProcessLotDTO) => void;
    lot?: ILot;
    catalogItemModel?: ICatalog_Item;
};

type State = {
    lot?: INewLot | ILot;
    catalogItemModel?: ICatalog_Item;
    catalogs?: ICatalog[];
    selectedCatalogGuid?: string;
    typeaheadItems?: ICatalog_Item[];
    isMultiEntry: boolean;
    hasUpdates: boolean;
};

class CreateLotSidebar extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            catalogItemModel: this.props.catalogItemModel,
            isMultiEntry: !this.props.catalogItemModel,
            hasUpdates: false,
        };
    }

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.CatalogItemOnProcessLot, this.onProcessLot);
        this.props.socket.on(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);
        this.props.socket.on(EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, this.onTypeaheadCatalogItem);

        this.setState(
            {
                lot:
                    this.props.lot ||
                    ({
                        supplier_id: this.props.supplierModel.id,
                        catalog_item_id: this.state.catalogItemModel?.id,
                        catalog_id: this.state.catalogItemModel?.catalog_id,
                    } as INewLot),
            },
            () => {
                if (!this.state.catalogItemModel) {
                    this.getCatalogs();
                }
            }
        );
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.CatalogItemOnProcessLot, this.onProcessLot);
        this.props.socket.removeListener(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);
        this.props.socket.removeListener(EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, this.onTypeaheadCatalogItem);
    }

    cancel = () => {
        this.props.cancel(this.state.hasUpdates);
    };

    save = () => {
        if (!this.state.lot) {
            return null;
        }

        const payload: IProcessLotDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            lot: this.state.lot,
        };

        let hasUpdates = this.state.hasUpdates;

        if (!payload.lot.catalog_item_id && this.state.catalogItemModel) {
            payload.lot.catalog_item_id = this.state.catalogItemModel.id;
            payload.lot.catalog_id = this.state.catalogItemModel.catalog_id;
            hasUpdates = true;
        }

        this.props.socket.emit(EndpointsEnum.CatalogItemProcessLot, payload);

        this.setState({
            hasUpdates,
        });
    };

    getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            callMeta: {
                view: "CreateLotSidebar",
                fn: "getCatalogs",
            },
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        this.setState({
            catalogs: data.catalogs,
        });
    };

    onTypeaheadCatalogItem = (data: IOnTypeaheadCatalogItemDTO) => {
        this.setState({
            typeaheadItems: data.catalog_items,
        });
    };

    onProcessLot = (data: IOnProcessLotDTO) => {
        this.props.cancel(this.state.hasUpdates, data);
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const lot = this.state.lot;

        // @ts-expect-error
        lot[name] = value;

        this.setState({ lot });
    };

    handleCatalogChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    selectDate = (date: Moment) => {
        if (!this.state.lot) {
            return null;
        }

        const lot = this.state.lot;

        lot.exp_date = date.toISOString(true);

        this.setState({
            lot,
        });
    };

    searchCatalogItem = (value: string) => {
        if (!this.state.selectedCatalogGuid) {
            return null;
        }

        const payload: ITypeaheadCatalogItemDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name: value,
            limit: 10,
            catalogGuid: this.state.selectedCatalogGuid,
            options: {
                searchName: true,
                searchDescription: true,
                searchSku: true,
                searchUpc: true,
            },
        };

        this.props.socket.emit(EndpointsEnum.CatalogItemTypeaheadCatalogItem, payload);
    };

    selectedCatalogItem = (catalogItem: ICatalog_Item) => {
        this.setState({
            catalogItemModel: catalogItem,
        });
    };

    render() {
        return (
            <div className="CreateLotSidebar p-2">
                <div className={"header"}>
                    <div className="text-end">
                        <button className="btn btn-danger btn-sm" onClick={this.cancel}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle leftIconName={"far fa-book"} title={"create_lot"} />
                    <hr />
                </div>

                {!this.state.isMultiEntry ? (
                    <div>
                        <div>
                            <OwLabel title={"catalog_item"} postText={":"} className={"me-2"} isBold={true} />
                            {this.state.catalogItemModel?.name}
                        </div>
                        <div>
                            <OwLabel title={"sku"} postText={":"} className={"me-2"} isBold={true} />
                            {this.state.catalogItemModel?.sku}
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className={"mb-3"}>
                            <OwLabel title={"catalog"} />
                            <OwSelectOption
                                valueProp={"guid"}
                                titleProp={"name"}
                                options={this.state.catalogs}
                                fn={this.handleCatalogChange}
                                selectedOption={this.state}
                                selectedOptionProp={"selectedCatalogGuid"}
                                name={"selectedCatalogGuid"}
                                showBlankFirst={true}
                            />
                        </div>
                        <div className={"mb-3"}>
                            <OwLabel title={"catalog_item"} />
                            <Typeahead
                                isSelectableFn={() => {
                                    return true;
                                }}
                                typeaheadApiFn={this.searchCatalogItem}
                                typeaheadItems={this.state.typeaheadItems}
                                titleProp={"name"}
                                selectedItemFn={this.selectedCatalogItem}
                                selectedItem={this.state.catalogItemModel}
                                selectedItemTitleProp={"name"}
                            />
                        </div>
                    </div>
                )}

                <div>
                    <div className={"mb-3"}>
                        <OwLabel title={"name"} />
                        <OwInputWrapper name={"name"} value={this.state.lot?.name} fn={this.handleChange} />
                    </div>
                    <div className={"mb-3"}>
                        <OwLabel title={"qty"} />
                        <OwFnInput name={"qty"} value={this.state.lot?.qty || 0} fn={this.handleChange} />
                    </div>
                    {this.props.supplierModel.has_exp_date ? (
                        <div className={"mb-3"}>
                            <OwLabel title={"exp_date"} />
                            <OwDateInput fn={this.selectDate} selectedDate={this.state.lot?.exp_date} />
                        </div>
                    ) : null}
                    <div>
                        <OwButton title={"save"} fn={this.save} />
                    </div>
                </div>
            </div>
        );
    }
}

export default CreateLotSidebar;
